// hooks/useOrganizations.ts
import { useEffect, useState, useCallback } from 'react';
import { useAuth } from './useAuth';
import {
  getOrganizationsRequest,
  getProjectsRequest,
  IOrganizations,
} from '../services/organisations';

export const useOrganizations = () => {
  const [organizations, setOrganizations] = useState<IOrganizations[]>([]);
  const [currentOrganization, setCurrentOrganization] = useState<IOrganizations | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const { userRolesFromToken } = useAuth();

  const getOrganizations = useCallback(async () => {
    setIsLoading(true);
    const response = await getOrganizationsRequest();
    setOrganizations(response.items);

    const { organizationId } = userRolesFromToken;

    if (organizationId && response.items.length) {
      const orgFromToken = response.items.find(
        (org: IOrganizations) => String(org.id) === String(organizationId)
      );

      if (orgFromToken) {
        setCurrentOrganization(orgFromToken);
      } else if (!currentOrganization) {
        setCurrentOrganization(response.items[0]);
      }
    } else if (!currentOrganization && response.items.length) {
      setCurrentOrganization(response.items[0]);
    }

    setIsLoading(false);
    return response.items;
  }, []);

  const changeOrganization = (organization: IOrganizations) => {
    setCurrentOrganization(organization);
    localStorage.setItem('organizationId', String(organization.id));
  };

  const getProjects = async (organizationId: number) => {
    return getProjectsRequest(organizationId);
  };

  useEffect(() => {
    getOrganizations();
  }, []);

  return {
    organizations,
    currentOrganization,
    changeOrganization,
    getOrganizations,
    getProjects,
    isLoading,
  };
};
